import { render } from "./UserBarMobile.vue?vue&type=template&id=0e53c4b7"
import script from "./UserBarMobile.vue?vue&type=script&lang=ts"
export * from "./UserBarMobile.vue?vue&type=script&lang=ts"
script.render = render

export default script